var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import getElementWidthHoc from '../../hoc/getElementWidthHoc';
var MARGIN = 20;
var InlineFlexibleLabel = /** @class */ (function (_super) {
    __extends(InlineFlexibleLabel, _super);
    function InlineFlexibleLabel(props) {
        var _this = _super.call(this, props) || this;
        _this.element = null;
        _this.resize = _this.resize.bind(_this);
        _this.state = { fontSize: _this.props.maxFontSize };
        return _this;
    }
    InlineFlexibleLabel.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ fontSize: this.props.maxFontSize }, function () { return _this.resize(_this.props.width); });
    };
    InlineFlexibleLabel.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        this.setState({ fontSize: nextProps.maxFontSize }, function () { return _this.resize(nextProps.width); });
    };
    InlineFlexibleLabel.prototype.resize = function (width) {
        var _this = this;
        if (width && this.element) {
            var elemWidth = this.element.offsetWidth;
            var wrapWidth = width - MARGIN;
            if (elemWidth > wrapWidth) {
                this.setState({ fontSize: this.state.fontSize - 1 }, function () { return _this.props.minFontSize && _this.props.minFontSize > _this.state.fontSize - 1 ? _this.props.minFontSize : _this.resize(width); });
            }
        }
    };
    InlineFlexibleLabel.prototype.render = function () {
        var _this = this;
        var value = this.props.value;
        return (React.createElement("div", { style: { width: '100%' } },
            React.createElement("div", { style: { fontSize: this.state.fontSize + "px" }, ref: function (r) { _this.element = r; }, className: "inlineFlexibleLabel" }, value)));
    };
    return InlineFlexibleLabel;
}(React.Component));
export default getElementWidthHoc(InlineFlexibleLabel);
//# sourceMappingURL=InlineFlexibleLabel.js.map